import React, { Fragment } from 'react'
import { Link } from 'gatsby'
import { Popover, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'

const pages = [
  { name: 'Public Status Pages', href: '/public-status-page' },
  { name: 'Private Status Pages', href: '/private-status-page' },
  { name: 'Status Badge', href: '/integrations/status-badge/' },
  { name: 'Status API', href: '/status-api' },
]
const usecases = [
  { name: 'Incidents', href: '/notices/incidents' },
  { name: 'Maintenance', href: '/notices/maintenance' },
  { name: 'Change Log', href: '/notices/general' },
]
const recentPosts = [
  {
    id: 1,
    title: 'Incident communication 101',
    href: '/incident-communications-101',
    category: { title: 'Book', href: '/resources/books' },
    imageUrl: '/images/101_nav.webp',
    description:
      'Mastering the art of communication during downtime and disruption.',
  },
  {
    id: 2,
    title: 'Why you need a status page',
    href: '/blog/why-you-need-a-status-page',
    category: { title: 'Blog', href: '/blog' },
    imageUrl: '/images/why_status_page.webp',
    description: 'Status pages build trust with real-time updates during incidents.',
  },
]

export default function NavigationFlyout() {
  return (
    <Popover className="relative">
      {({ open }) => (
        <>
          <Popover.Button className="inline-flex items-center gap-x-1 text-sm font-semibold leading-6 text-gray-900">
            Status Pages
            <ChevronDownIcon 
              className={`h-5 w-5 transition duration-150 ease-in-out ${
                open ? 'rotate-180 transform' : ''
              }`} 
              aria-hidden="true" 
            />
          </Popover.Button>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel className="absolute -left-8 z-10 mt-6 w-screen max-w-[950px] transform">
              <div className="overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-gray-900/5">
                <div className="grid grid-cols-2 gap-x-6 lg:gap-x-8 p-6 lg:p-8">
                  <div className="grid grid-cols-2 gap-x-6 lg:gap-x-8">
                    <div>
                      <p className="text-sm font-medium text-gray-500">Hosted & easy to setup</p>
                      <ul className="mt-4 space-y-4">
                        {pages.map((item) => (
                          <li key={item.name}>
                            <Link to={item.href} className="text-sm font-semibold text-gray-900 hover:text-gray-600">
                              {item.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-500">One tool for communicating</p>
                      <ul className="mt-4 space-y-4">
                        {usecases.map((item) => (
                          <li key={item.name}>
                            <Link to={item.href} className="text-sm font-semibold text-gray-900 hover:text-gray-600">
                              {item.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-x-6 lg:gap-x-8">
                    {recentPosts.map((post) => (
                      <article key={post.id} className="group relative">
                        <div className="aspect-[16/9] overflow-hidden rounded-lg bg-gray-100">
                          <img
                            src={post.imageUrl}
                            alt=""
                            width={320}
                            height={180}
                            loading="lazy"
                            className="object-cover w-full h-full group-hover:opacity-75"
                          />
                        </div>
                        <div className="mt-3">
                          <div>
                            <Link to={post.category.href} className="inline-flex items-center rounded-full bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                              {post.category.title}
                            </Link>
                          </div>
                          <h3 className="mt-2">
                            <Link to={post.href} className="text-sm font-semibold text-gray-900 hover:text-gray-600">
                              <span className="absolute inset-0" />
                              {post.title}
                            </Link>
                          </h3>
                          <p className="mt-2 text-sm text-gray-500">{post.description}</p>
                        </div>
                      </article>
                    ))}
                  </div>
                </div>
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  )
}